module.exports = __webpack_public_path__ + "b2858f5eaf6d687e01e49bbfdc52656e.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/head/RRR.jpg
// module id = 621
// module chunks = 0